[
  {
    "code": "YE-AD",
    "name": "'Adan"
  },
  {
    "code": "YE-AM",
    "name": "'Amran"
  },
  {
    "code": "YE-AB",
    "name": "Abyan"
  },
  {
    "code": "YE-DA",
    "name": "Ad¸ D¸ali'"
  },
  {
    "code": "YE-BA",
    "name": "Al Bayda'"
  },
  {
    "code": "YE-HU",
    "name": "Al Hudaydah"
  },
  {
    "code": "YE-JA",
    "name": "Al Jawf"
  },
  {
    "code": "YE-MR",
    "name": "Al Mahrah"
  },
  {
    "code": "YE-MW",
    "name": "Al Mahwit"
  },
  {
    "code": "YE-DH",
    "name": "Dhamar"
  },
  {
    "code": "YE-HD",
    "name": "Hadramawt"
  },
  {
    "code": "YE-HJ",
    "name": "Hajjah"
  },
  {
    "code": "YE-IB",
    "name": "Ibb"
  },
  {
    "code": "YE-LA",
    "name": "Lahij"
  },
  {
    "code": "YE-MA",
    "name": "Ma'rib"
  },
  {
    "code": "YE-SD",
    "name": "Sa'dah"
  },
  {
    "code": "YE-SN",
    "name": "San'a'"
  },
  {
    "code": "YE-SA",
    "name": "San‘a’ [city]"
  },
  {
    "code": "YE-SH",
    "name": "Shabwah"
  },
  {
    "code": "YE-TA",
    "name": "Ta'izz"
  }
]